module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture32-f5c33344628c93e23f2fae597cf3ee7e.jpg";